module.exports = __webpack_public_path__ + "img/canbadge_heart_w57mm_trimmark.6f42113f.png";